/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-toggle-list': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M6.25 3.75H17.5V5H6.25V3.75zm0 11.25H17.5v1.25H6.25V15zm0-5.625H17.5v1.25H6.25v-1.25zm-3.75 0h1.25v1.25H2.5v-1.25zm0-5.625h1.25V5H2.5V3.75zM2.5 15h1.25v1.25H2.5V15z"/>'
  }
})
